import React from "react";
import { addPossessive } from "@brz-shared/add.possesive"
import { useGlobal } from "@brz-utils/contexts/global.context";
import { QuoteProposalDataModel } from "@brz-components/sections/quote.proposal/section.quote.proposal";
import { useClass } from "@breezerr";
import { IneligibleClientModel } from "src/pages/disability-insurance/ineligible/_data.model";


export const RichClientName = (props: any) => {
    const { data } = useGlobal<QuoteProposalDataModel | IneligibleClientModel>('client');
    const [name, setName] = React.useState(props.fallback || '');

    React.useEffect(() => {
        if ( data && data.firstName && data.lastName ) {
            const names = [
                ...(props.useFirstName ? [data.firstName] : []),
                ...(props.useLastName ? [data.lastName] : []),
            ];

            if ( !props.useFirstName && !props.useLastName ) {
                names.push(data.firstName, data.lastName);
            }

            const name = names.join(' ').trim();

            if ( props.usePossesive ) {
                setName(addPossessive(name || props.fallback));
            } else {
                setName(name);
            }
        }
    }, [data]);

    return name ? (
        <span className={useClass(`p-relative d-inline-flex ${props.highlight ? `${props.highlightColor ? (props.highlightColor === 'accent' ? 'bg-color-accent:200' : 'bg-color-secondary:600') : 'bg-color-grey:300'} radius-1rem py-0.5rem px-2rem -ml-2rem sm:ml-0x lg:-ml-2rem border-box` : ''}`)}>
            { name }
        </span>
    ) : <></>
}